<template>
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-4 border-b border-gray-200 flex items-center space-x-3">
      <span class="material-symbols-outlined text-xl text-primary">workspace_premium</span>
      <h2 class="text-lg font-semibold text-gray-800">Current Subscription</h2>
    </div>
    
    <div v-if="profile?.plan" class="p-6">
      <div class="space-y-6">
        <!-- Plan Details -->
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-primary to-primary-dark rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-2xl text-white">workspace_premium</span>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 text-left">Current Plan</p>
            <p class="mt-1 text-xl font-bold text-gray-900 capitalize text-left">{{ profile.plan.name }}</p>
            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mt-2"
              :class="getStatusClasses(profile.plan)">
              {{ getStatusText(profile.plan) }}
            </span>
          </div>
        </div>
        
        <!-- Price Info -->
        <div v-if="profile.plan.price" class="flex items-center space-x-4">
          <div class="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-green-600">payments</span>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 text-left">Monthly Price</p>
            <p class="mt-1 text-lg font-semibold text-gray-900 text-left">
              {{ formatCurrency(profile.plan.price, profile.plan.currency) }}/month
            </p>
          </div>
        </div>

        <!-- Last Payment -->
        <div v-if="profile.plan.lastPaymentDate" class="flex items-center space-x-4">
          <div class="flex-shrink-0 w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-blue-600">receipt</span>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 text-left">Last Payment</p>
            <p class="mt-1 text-base text-gray-900 text-left">{{ formatDate(profile.plan.lastPaymentDate) }}</p>
          </div>
        </div>

        <!-- Next Billing -->
        <div v-if="profile.plan.renewsAt && profile.plan.active && !profile.plan.cancelledAt" class="flex items-center space-x-4">
          <div class="flex-shrink-0 w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-purple-600">event</span>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 text-left">Next Billing</p>
            <p class="mt-1 text-base text-gray-900 text-left">{{ formatDate(profile.plan.renewsAt) }}</p>
          </div>
        </div>

        <!-- Payment Method -->
        <div v-if="profile.plan.cardBrand && profile.plan.cardLastFour" class="flex items-center space-x-4">
          <div class="flex-shrink-0 w-10 h-10 bg-yellow-50 rounded-lg flex items-center justify-center">
            <span class="material-symbols-outlined text-yellow-600">credit_card</span>
          </div>
          <div>
            <p class="text-sm font-medium text-gray-500 text-left">Payment Method</p>
            <p class="mt-1 text-base text-gray-900 capitalize text-left">
              {{ profile.plan.cardBrand }} •••• {{ profile.plan.cardLastFour }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentSubscriptionOverview',
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    },
    
    formatCurrency(amount) {
      if (typeof amount !== 'number' || isNaN(amount)) return '';
      return `$${amount.toFixed(2)}`;
    },

    getStatusClasses(plan) {
      if (plan.name === 'free') {
        return 'bg-green-100 text-green-800';
      }
      if (plan.active && plan.cancelledAt) {
        return 'bg-yellow-100 text-yellow-800';
      } else if (plan.active) {
        return 'bg-green-100 text-green-800';
      } else {
        return 'bg-red-100 text-red-800';
      }
    },

    getStatusText(plan) {
      if (plan.name === 'free') {
        return 'Active';
      }
      if (plan.active && plan.cancelledAt) {
        return 'Active';
      } else if (plan.active) {
        return 'Active';
      } else if (plan.cancelledAt) {
        return 'Cancelled';
      } else {
        return 'Inactive';
      }
    }
  }
};
</script>
